import React from 'react';
import MarkdownRender from '@/components/text-editors/MarkdownRender';
import AnnouncementCount from './AnnouncementCount';
import AnnouncementHeadline from './AnnouncementHeadline';
import AnnouncementIcon from './AnnouncementIcon';
import Selectors from '../hooks/selectors';

const AnnouncementContent = () => {
  const {
    count, dateTimeFrom, dateTimeTo, headline, index, level, linkedContent,
  } = Selectors.useAnnouncementContent();

  return (
    <>
      <AnnouncementIcon level={level} />
      <div className="content aridhia-announcement-content">
        <AnnouncementHeadline dateTimeFrom={dateTimeFrom} dateTimeTo={dateTimeTo} headline={headline} />
        {count > 1 && (<AnnouncementCount index={index + 1} count={count} />)}
        <MarkdownRender value={linkedContent} className="aridhia-markdown-table mb-0 f-12 mt-m4" />
      </div>
    </>
  );
};

export default AnnouncementContent;
